module.exports = __webpack_public_path__ + "img/suenio_danger.265824f2.svg";